/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { Button, TextField } from "@mui/material";
import { useState } from "react";
import clone_object from "../lib/clone_object";

export default function WhatsNewMapping({ data, imgUpload, setData }) {
  const [selectMap, setSelectMap] = useState();
  const addMapping = () => {
    setData((state) => {
      const copy = { ...state };
      const c_body_img = [...copy.meta_bodyimg];
      c_body_img.push({
        width: "10",
        height: "10",
        top: "0",
        left: "0",
        url: "",
      });
      return { ...copy, meta_bodyimg: c_body_img };
    });
  };

  const deleteMapping = () => {
    setData((state) => {
      const copy = clone_object(state);
      copy.meta_bodyimg.splice(selectMap, 1);
      return copy;
    });
    setSelectMap();
  };

  return (
    <div
      css={css`
        display: flex;
        width: 100%;
        min-height: 500px;
        gap: 0.5rem;
      `}
    >
      <div
        css={css`
          width: 100%;
          border: 1px dashed gray;
          position: relative;
          -webkit-user-select: none;
          -moz-user-select: none;
          -ms-user-select: none;
          user-select: none;
        `}
        onClick={() => setSelectMap()}
      >
        <img
          src={data.body_img.src}
          alt=""
          css={css`
            width: 100%;
            object-fit: contain;
          `}
          draggable={false}
        />
        {data.meta_bodyimg.map((data, index) => (
          <div
            key={index}
            css={css`
              position: absolute;
              background: rgba(0, 0, 0, 0.3);
              border: 1px dashed ${index === selectMap ? "red" : "lightgrey"};
              cursor: pointer;
              top: ${data.top}%;
              left: ${data.left}%;
              width: ${data.width}%;
              height: ${data.height}%;
            `}
            onClick={(e) => {
              e.stopPropagation();
              setSelectMap(index);
            }}
          />
        ))}
      </div>
      <div
        css={css`
          width: 300px;
          display: flex;
          flex-direction: column;
          gap: 0.25rem;
        `}
      >
        <label>
          <Button
            variant="outlined"
            onClick={(e) => e.target.nextSibling.click()}
            css={css`
              width: 100%;
            `}
          >
            이미지 업로드
          </Button>
          <input
            type="file"
            css={css`
              display: none;
            `}
            name="body_img"
            onChange={imgUpload}
            accept="image/*"
          />
        </label>
        {data.body_img && (
          <Button variant="outlined" onClick={addMapping}>
            맵핑 박스 추가
          </Button>
        )}
        {!!data.meta_bodyimg.length && (
          <div
            css={css`
              text-align: center;
              display: flex;
              flex-direction: column;
              gap: 0.5rem;
              margin-top: 2rem;
            `}
          >
            <span>선택된 맵핑</span>
            {selectMap === undefined ? (
              <span
                css={css`
                  padding: 1rem 0;
                `}
              >
                맵핑을 선택하세요
              </span>
            ) : (
              <>
                {Object.keys(data.meta_bodyimg[selectMap]).map((key, index) => (
                  <div
                    key={index}
                    css={css`
                      display: flex;
                      gap: 0.25rem;
                      align-items: center;
                    `}
                  >
                    <TextField
                      type={key !== "url" ? "number" : "text"}
                      sx={css`
                        width: 100%;
                      `}
                      value={data.meta_bodyimg[selectMap][key]}
                      size="small"
                      label={key}
                      onChange={(e) =>
                        setData((state) => {
                          const copy = clone_object(state);
                          copy.meta_bodyimg[selectMap][key] = e.target.value;
                          return copy;
                        })
                      }
                    />
                    {key !== "url" && "%"}
                  </div>
                ))}
                <span
                  css={css`
                    font-size: 12px;
                    opacity: 0.6;
                  `}
                >
                  앱 내 링크만 가능
                </span>
                <Button
                  variant="outlined"
                  color="error"
                  onClick={deleteMapping}
                >
                  맵핑 박스 삭제
                </Button>
              </>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
